"use client"

import { useMemo } from 'react';
import * as S from './VideoSectionStyle'
import { usePathname } from 'next/navigation'
import { useTranslation } from 'react-i18next';

const VideoSection = () => {
    const { t } = useTranslation();
    const pathname = usePathname();
    const breadcrumb = useMemo(() => {
        const name = pathname.replace("/", "").toUpperCase();
        return name ? name : "LINK FOR NEXT";
    }, [pathname]);

    return (
        <S.VideoSectionContainer>
            <video 
                src="/video/video.mp4" 
                autoPlay 
                muted 
                loop
                style={{
                    backgroundColor: "black",
                    position: "absolute",
                    userSelect: "none",
                    minHeight: "100%",
                    minWidth: "100%",
                    objectFit: "cover",
                }} 
            />
            <S.VideoSectionContent dangerouslySetInnerHTML={{__html: t('video_title')}} />
            <S.VideoSectionBottom>
                <S.VideoSectionBottomLink>
                    <h2>{breadcrumb}</h2>
                    <hr/>
                </S.VideoSectionBottomLink>
            </S.VideoSectionBottom>
        </S.VideoSectionContainer>
    )
}

export default VideoSection